import { localeEn, localeIdID, localeMsMY, localeThTH, localeViVN, localeZhCN } from '@m4b-seller/utils';

export enum LANG {
  EN = 'en',
  ID_ID = 'id-ID',
  VN = 'vi-VN',
  TH_TH = 'th-TH',
  MS_MY = 'ms-MY',
  ZH_CN = 'zh-CN',
  PT_BR = 'pt-BR',
  ES = 'es',
  EN_GB = 'en-GB',
  ES_419 = 'es-419',
  DE_DE = 'de-DE',
  IT_IT = 'it-IT',
  FR = 'fr',
  JA_JP = 'ja-JP',
  NL_NL = 'nl-NL',
  PL_PL = 'pl-PL'
}

export const M4BLanguageMap = {
  [LANG.EN]: localeEn,
  [LANG.ID_ID]: localeIdID,
  [LANG.VN]: localeViVN,
  [LANG.TH_TH]: localeThTH,
  [LANG.MS_MY]: localeMsMY,
  [LANG.ZH_CN]: localeZhCN
};

export const LANG_MAP = {
  [LANG.EN]: 'English',
  [LANG.EN_GB]: 'UK English',
  [LANG.ID_ID]: 'Bahasa Indonesia',
  [LANG.VN]: 'Tiếng Việt',
  [LANG.TH_TH]: 'ไทย',
  [LANG.MS_MY]: 'Bahasa Melayu',
  [LANG.ZH_CN]: '简体中文',
  [LANG.ES]: 'Español',
  [LANG.ES_419]: 'Español (Latinoamérica)',
  [LANG.DE_DE]: 'Deutsch',
  [LANG.IT_IT]: 'Italiano',
  [LANG.FR]: 'Français',
  [LANG.PT_BR]: 'Português (Brasil)',
  [LANG.JA_JP]: '日本語です',
  [LANG.NL_NL]: 'Nederlands',
  [LANG.PL_PL]: 'Polski'
};

export enum REGION {
  GB = 'GB',
  ID = 'ID',
  VN = 'VN',
  MY = 'MY',
  TH = 'TH',
  PH = 'PH',
  SG = 'SG',
  US = 'US',
  IE = 'IE',
  ES = 'ES',
  DE = 'DE',
  IT = 'IT',
  FR = 'FR',
  MX = 'MX',
  BR = 'BR',
  JP = 'JP',
  NL = 'NL',
  PL = 'PL',
  CZ = 'CZ',
  GR = 'GR',
  PT = 'PT',
  HU = 'HU',
  BE = 'BE',
  AT = 'AT'
}

export const REGION_MAP = {
  [REGION.MX]: REGION.MX,
  [REGION.BR]: REGION.BR,
  [REGION.JP]: REGION.JP
};
// If region-config cannot be obtained, get privacy compliance url from this map
export const REGION_POLICY_LINK_MAP = {
  [REGION.GB]: 'https://seller-uk.tiktok.com/university/article/agreement?knowledge_id=10001432',
  [REGION.ID]: 'https://seller-id.tiktok.com/university/article/agreement?knowledge_id=10000863',
  [REGION.MY]: 'https://seller-my.tiktok.com/university/article/agreement?knowledge_id=10008258',
  [REGION.TH]: 'https://seller-th.tiktok.com/university/article/agreement?knowledge_id=10008260',
  [REGION.VN]: 'https://seller-vn.tiktok.com/university/article/agreement?knowledge_id=10008265',
  [REGION.PH]: 'https://seller-ph.tiktok.com/university/article/agreement?knowledge_id=10009199',
  [REGION.SG]: 'https://seller-sg.tiktok.com/university/article/agreement?knowledge_id=10011081',
  [REGION.US]: 'https://seller-us.tiktok.com/university/article/agreement?knowledge_id=10013713&identity=1',
  [REGION.IE]: 'https://www.tiktok.com/legal/page/eea/privacy-policy/en',
  [REGION.ES]: 'https://www.tiktok.com/legal/page/eea/privacy-policy/en',
  [REGION.CZ]: 'https://www.tiktok.com/legal/page/global/partner-privacy-policy/cs',
  [REGION.HU]: 'https://www.tiktok.com/legal/page/global/partner-privacy-policy/en',
  [REGION.NL]: 'https://www.tiktok.com/legal/page/global/partner-privacy-policy/nl',
  [REGION.PL]: 'https://www.tiktok.com/legal/page/global/partner-privacy-policy/pl',
  [REGION.GR]: 'https://www.tiktok.com/legal/page/global/partner-privacy-policy/en',
  [REGION.PT]: 'https://www.tiktok.com/legal/page/global/partner-privacy-policy/pt',
  [REGION.BR]: 'https://seller-br.tiktok.com/university/essay?knowledge_id=3268441302615809&identity=1',
  [REGION.MX]: 'https://seller-mx.tiktok.com/university/essay?knowledge_id=6295443664750337&identity=1',
  [REGION.BE]: 'https://www.tiktok.com/legal/page/global/partner-privacy-policy/fr',
  [REGION.AT]: 'https://www.tiktok.com/legal/page/global/partner-privacy-policy/de',
  default: 'https://www.tiktok.com/legal/page/eea/privacy-policy/en'
};
// List of languages under the current domain
export const LANG_REGION_MAP = {
  [LANG.EN]: [REGION.ID, REGION.VN, REGION.TH, REGION.MY, REGION.PH, REGION.SG, REGION.MX, REGION.BR, REGION.JP],
  [LANG.ID_ID]: [REGION.ID],
  [LANG.VN]: [REGION.VN],
  [LANG.TH_TH]: [REGION.TH],
  [LANG.MS_MY]: [REGION.MY],
  [LANG.DE_DE]: [REGION.DE],
  [LANG.IT_IT]: [REGION.IT],
  [LANG.FR]: [REGION.FR],
  [LANG.ES]: [REGION.ES],
  [LANG.ES_419]: [REGION.MX],
  [LANG.PT_BR]: [REGION.BR],
  [LANG.JA_JP]: [REGION.JP],
  [LANG.NL_NL]: [REGION.NL],
  [LANG.PL_PL]: [REGION.PL],
  GB: [
    REGION.GB,
    REGION.ES,
    REGION.IE,
    REGION.DE,
    REGION.IT,
    REGION.FR,
    REGION.NL,
    REGION.PL,
    REGION.CZ,
    REGION.GR,
    REGION.PT,
    REGION.HU,
    REGION.BE,
    REGION.AT
  ],
  CB: [
    REGION.VN,
    REGION.TH,
    REGION.MY,
    REGION.PH,
    REGION.SG,
    REGION.GB,
    REGION.ES,
    REGION.FR,
    REGION.NL,
    REGION.PL,
    REGION.CZ,
    REGION.GR,
    REGION.PT,
    REGION.HU,
    REGION.BE,
    REGION.AT,
    REGION.DE,
    REGION.IT,
    REGION.US,
    REGION.MX,
    REGION.JP
  ]
};

export const REGION_TEXT_MAP = {
  [REGION.GB]: 'pc_gb',
  [REGION.ID]: 'pc_id',
  [REGION.VN]: 'pc_vn',
  [REGION.MY]: 'pc_my',
  [REGION.TH]: 'pc_th',
  [REGION.PH]: 'pc_ph',
  [REGION.SG]: 'pc_sg',
  [REGION.US]: 'pc_us',
  [REGION.DE]: 'sellercenter_common_country_name_german',
  [REGION.IT]: 'sellercenter_common_country_name_italy',
  [REGION.FR]: 'sellercenter_common_country_france',
  [REGION.ES]: 'sellercenter_common_country_spain',
  [REGION.IE]: 'sellercenter_common_country_ireland',
  [REGION.MX]: 'academy_footer_popup_contact_site_mx',
  [REGION.BR]: 'sellercenter_common_country_brasil',
  [REGION.JP]: 'sellercenter_common_country_japan',
  [REGION.NL]: 'sellercenter_common_country_netherlands',
  [REGION.PL]: 'sellercenter_common_country_poland',
  [REGION.CZ]: 'sellercenter_common_country_czech_republic',
  [REGION.GR]: 'sellercenter_common_country_greece',
  [REGION.PT]: 'sellercenter_common_country_portugal',
  [REGION.HU]: 'sellercenter_common_country_hungary',
  [REGION.BE]: 'sellercenter_common_country_belgium',
  [REGION.AT]: 'sellercenter_common_country_austria'
};

// Solve the problem that there is no route redirection to tiktok when jumping to ato page under the current domain
export const SKIP_ATO_LINK = {
  [REGION.MX]: 'ota/su-tcatnoc/moc.kotkit.relles//:sptth'.split('').reverse().join(''),
  [REGION.BR]: 'ota/su-tcatnoc/moc.kotkit.relles//:sptth'.split('').reverse().join('')
};

export const SELLER_TCC_CDN = {
  VA: 'https://sf16-tcc-tos-va.byteoversea.com/obj/tcc-config-web-maliva/tcc-v2-data-ies.feedback.magellan-pc',
  SG: 'https://sf16-tcc-tos-sg.byteoversea.com/obj/tcc-config-web-alisg/tcc-v2-data-ies.feedback.magellan-pc',
  GCP: 'https://lf16-tcc-tos-i18n.byteoversea.com/obj/tcc-config-web-euttp/tcc-v2-data-ies.feedback.magellan-pc',
  TTP: 'https://lf16-config.tiktokcdn-us.com/obj/tcc-config-web-tx/tcc-v2-data-ies.feedback.magellan-default'
};
